import * as types from './types';
import { replace } from 'react-router-redux';
import { loading, success, error } from 'State/actions';
import { resetDirty } from 'State/dirtyTracking/actions';

export const getSiteStorageLocByItem = itemId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ITEM_STORAGE_LOCATION_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `AssignEntities/GetSiteStorageLocByItem/${itemId}`
      );
      dispatch(
        success(types.ITEM_STORAGE_LOCATION_DATA, response.data.Data.Data)
      );
    } catch (ex) {
      dispatch(error(types.ITEM_STORAGE_LOCATION_LOADING_ERROR, ex));
    } finally {
      dispatch(loading(types.ITEM_STORAGE_LOCATION_LOADING, false));
    }
  };
};
export const saveItemStorageLocation = (model, resetScroll) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ITEM_STORAGE_LOCATION_SUBMITTING, true));
    resetScroll();

    try {
      await MPWWebApi.postGenericInsertUpdate(
        `AssignEntities/WriteSiteStorageLocByItem/${model.ItemId}`,
        model.SiteStorageLocationMapping
      );

      dispatch(resetDirty());
      dispatch(success(types.ITEM_STORAGE_LOCATION_SUBMIT));
      dispatch(replace('/itemmaintenance'));
    } catch (ex) {
      dispatch(error(types.ITEM_STORAGE_LOCATION_SUBMIT_ERROR, ex));
    }

    dispatch(loading(types.ITEM_STORAGE_LOCATION_SUBMITTING, false));
  };
};
export const clearItemSubmitError = () => {
  return {
    type: types.CLEAR_ITEM_ERROR_SUCCESS,
  };
};

export const getStorageLocation = storageLocationEnum => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ITEM_STORAGE_LOCATION_DROPDOWN_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `InvGroup/GetStorageLocations/${storageLocationEnum}`
      );
      dispatch(
        success(types.ITEM_STORAGE_LOCATION_DROPDOWN_DATA, response.data.Data)
      );
    } catch (ex) {
      dispatch(error(types.ITEM_STORAGE_LOCATION_DROPDOWN_LOADING_ERROR, ex));
    } finally {
      dispatch(loading(types.ITEM_STORAGE_LOCATION_DROPDOWN_LOADING, false));
    }
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/state/itemStorageLocation/actions.js